// Application versioning
export var Version;
(function (Version) {
    Version["v1"] = "version-1";
    Version["v2"] = "version-2";
})(Version || (Version = {}));
//# sourceMappingURL=general.js.map